import styled from "styled-components";
import { TotalBalanceBlock } from "./TotalBalanceBlock";

export const TotalBalance = ({ balance }: IProps) => {
	if (!balance) {
		return <></>;
	}
	return (
		<StyledComponent>
			<div className="token">
				<div className="title">ETH (токен / комиссия)</div>
				<TotalBalanceBlock block={balance?.eth} />
			</div>
			<div className="token">
				<div className="title">ERC20 (сума / комиссия)</div>
				<TotalBalanceBlock block={balance?.erc20} />
			</div>
			<div className="token">
				<div className="title">TRX (сума / комиссия)</div>
				<TotalBalanceBlock block={balance?.trx} />
			</div>
			<div className="token">
				<div className="title">TRC20 (сума / комиссия)</div>
				<TotalBalanceBlock block={balance?.trc20} />
			</div>
		</StyledComponent>
	);
};

const StyledComponent = styled.div`
	display: flex;
	gap: 2rem;

	& .token {
		flex-grow: 1;
		border: 1px solid rgba(255, 255, 255, 0.1);
	}
`;

interface IProps {
	balance?: {
		[key: string]: any;
	};
}
